import { render, staticRenderFns } from "./MarketHome.vue?vue&type=template&id=34415c82&scoped=true"
import script from "./MarketHome.vue?vue&type=script&lang=js"
export * from "./MarketHome.vue?vue&type=script&lang=js"
import style0 from "./MarketHome.vue?vue&type=style&index=0&id=34415c82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34415c82",
  null
  
)

export default component.exports